import firebase from 'firebase/app';
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyA_Qo4sUCSSdFB1LH8cK0lvfbFGKH5J6Mw",
  authDomain: "ivris-checklista.firebaseapp.com",
  projectId: "ivris-checklista",
  storageBucket: "ivris-checklista.appspot.com",
  messagingSenderId: "741742567544",
  appId: "1:741742567544:web:d15f6f89b01b4434dacd8d",
  measurementId: "G-HJMNPGPTLP"
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();

export { storage, firebase as default } 